import { CommonModule, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats, MatNativeDateModule } from '@angular/material/core';
import { PtBrDateAdapter } from './pt-br-date-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClipboardModule } from 'ngx-clipboard';
import { CartaoMaskDirective, CepMaskDirective, CnpjDirective, CpfCnpjDirective, CpfDirective, DateDirective, NumbersOnlyDirective, PhoneDirective, TrimReactiveDirective, ValidadeMaskDirective } from '../directives';
import { PipeModule } from './pipe.module';
import { FuseAlertComponent } from '@fuse/components/alert';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export const MOMENT_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'DD/MM/YYYY'
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMMM Y',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM Y'
    }
};

const MATERIAL = [
    MatSnackBarModule,
    MatInputModule,
    MatTooltipModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatSelectModule,
    MatDividerModule,
    MatRadioModule,
    MatDialogModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatCardModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatTabsModule,
    MatStepperModule
];

const OTHERS = [
    ReactiveFormsModule,
    NgIf,
    NgFor,
    RouterLink,
    FormsModule,
    ClipboardModule,
    PipeModule,
    TranslateModule,
    FuseAlertComponent
];

const DIRECTIVES = [
    CpfDirective,
    CnpjDirective,
    CpfCnpjDirective,
    DateDirective,
    CepMaskDirective,
    TrimReactiveDirective,
    PhoneDirective,
    ValidadeMaskDirective,
    CartaoMaskDirective,
    NumbersOnlyDirective
];

@NgModule({
    declarations: [
        ...DIRECTIVES
    ],
    imports: [
        CommonModule,
        ...OTHERS,
        ...MATERIAL,
    ],
    exports: [
        CommonModule,
        ...OTHERS,
        ...MATERIAL,
        ...DIRECTIVES
    ],
    providers: [
        TranslateService,
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
        { provide: DateAdapter, useClass: PtBrDateAdapter },
    ]
})
export class DefaultComponentsModule { }
